import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const SettingmasterEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		entityid: yup.string().nullable().label($t('entityid')),
		userid: yup.string().nullable().label($t('userid')),
		senderid: yup.string().nullable().label($t('senderid')),
		url: yup.string().nullable().label($t('url')),
		url_parameters: yup.string().nullable().label($t('urlParameters')),
		token: yup.string().nullable().label($t('token'))
	});
	// form default values
	const formDefaultValues = {
		entityid: '', 
		userid: '', 
		senderid: '', 
		url: '', 
		url_parameters: '', 
		token: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/settingmaster`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="SettingmasterEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editSettingmaster')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('entityid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="entityid"  onChange={formik.handleChange}  value={formik.values.entityid}   label={$t('entityid')} type="text" placeholder={$t('enterEntityid')}        className={inputClassName(formik?.errors?.entityid)} />
                                                <ErrorMessage name="entityid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('userid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label={$t('userid')} type="text" placeholder={$t('enterUserid')}        className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('senderid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="senderid"  onChange={formik.handleChange}  value={formik.values.senderid}   label={$t('senderid')} type="text" placeholder={$t('enterSenderid')}        className={inputClassName(formik?.errors?.senderid)} />
                                                <ErrorMessage name="senderid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('url')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="url"  onChange={formik.handleChange}  value={formik.values.url}   label={$t('url')} type="text" placeholder={$t('enterUrl')}        className={inputClassName(formik?.errors?.url)} />
                                                <ErrorMessage name="url" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('urlParameters')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputTextarea name="url_parameters"  className={inputClassName(formik?.errors?.url_parameters)}   value={formik.values.url_parameters} placeholder={$t('enterUrlParameters')} onChange={formik.handleChange}   >
                                                </InputTextarea>
                                                <ErrorMessage name="url_parameters" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('token')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="token"  onChange={formik.handleChange}  value={formik.values.token}   label={$t('token')} type="text" placeholder={$t('enterToken')}        className={inputClassName(formik?.errors?.token)} />
                                                <ErrorMessage name="token" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
SettingmasterEditPage.defaultProps = {
	primaryKey: 'entityid',
	pageName: 'settingmaster',
	apiPath: 'settingmaster/edit',
	routeName: 'settingmasteredit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default SettingmasterEditPage;
